import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0264b8f0")
const _hoisted_1 = { class: "group-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "no-data-text" }, "当前暂无分组，请对学生进行分组", -1)
const _hoisted_4 = { class: "group-flex" }
const _hoisted_5 = { class: "score-both" }
const _hoisted_6 = { class: "score-both-add" }
const _hoisted_7 = { class: "score-both-reduce" }
const _hoisted_8 = { class: "student-container" }
const _hoisted_9 = { class: "operation" }
const _hoisted_10 = { class: "relate" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "check-box-label" }, "全选", -1)
const _hoisted_12 = {
  class: "base-btn confirm",
  style: {"margin-left":"30px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_14 = {
  key: 1,
  style: {"height":"4rem"}
}
_popScopeId()

import { ref, inject, computed, watch } from "vue";
import { ClassroomInterationNS } from "../../types";
import GroupCard from "../base/GroupCard.vue";
import BaseModal from "../base/BaseModal.vue";
import StudentCard from "../base/StudentCard.vue";
import { ElMessage } from "element-plus";
import {
  addStudentEvaluateRecord,
  addGroupEvaluateRecord,
  setGroupEvaluateNormScoreByStudentSum,
} from "@/services/classroomInteraction";
import RandomModal from "./randomModal.vue";
import { delayLoading } from "../../utils";
import { reportStat } from "@/utils/statDataReport";
import { useStore } from "vuex";


export default _defineComponent({
  emits: ["onStartCreate"] as unknown as undefined,
  setup(__props, { expose, emit }: { emit: ({
  (event: "onStartCreate", newVisible: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const store = useStore();
const groupEvaluateData = inject("groupEvaluateData");
const currentGroupInfo = inject("currentGroupInfo");
// 展示全局评价弹窗
const handleShowAppraiseModal = inject("handleShowAppraiseModal");
const multiSelectAction = inject<any>("multiSelectAction");
const groupPlanId = inject<any>("groupPlanId");
const handleCreateGroup = inject<any>("handleCreateGroup", () => null, false);
const changeIsAllSelected = inject<any>(
  "changeIsAllSelected",
  () => null,
  false
);
const handleUpdateStudentAndGroupData = inject(
  "handleUpdateStudentAndGroupData",
  () => null,
  false
);
const handleShowMask =
  inject<(config: ClassroomInterationNS.MaskInfoType) => void>(
    "handleShowMask"
  );

const handleAppraiseModalClose: any = inject("handleCloseAppraiseModal");
const pointStyle = {
  width: "41px",
  height: "26px",
};
// 所有小组数据
const groupList = computed(() => {
  return (
    groupEvaluateData.value.map((g, gIdx) => {
      g.addScore = g.lesson_evaluate_total_score.find(
        (i) => i.norm_type === 1
      ).total_score;
      g.subtractScore = g.lesson_evaluate_total_score.find(
        (i) => i.norm_type === 0
      ).total_score;
      g.avatarId = (gIdx % 8) + 1;
      // g.checked = false;
      return g;
    }) || []
  );
});
// 小组页面显示数据
const groupListShowData = ref([]);

const lessonId = inject<any>("lessonId");
const allSelect = ref(false);
const modalVisible = ref(false);
const title = ref("");
const currentGroup = ref();
const currentStudentList = ref<any[]>([]);

// 动画效果相关
const animationtionInfo = ref<{ visible: boolean; score: number }>({
  visible: false,
  score: 1,
});

const handleOpenModal = (group: any, isRandom = false) => {
  if (isRandom) {
    multiSelectAction.value = false;
  }
  if (!group.students.length) {
    ElMessage.info("该组没有学生，无法点评");
    return;
  }
  if (!multiSelectAction.value) {
    title.value = `单组点评:${group.name}`;
    modalVisible.value = true;
    currentGroup.value = group;
    currentStudentList.value = currentGroup.value.students.map((i) => {
      i.checked = true;
      return i;
    });
  } else {
    group.checked = !group.checked;
  }
};
const checkBoxChecked = computed(
  () =>
    currentStudentList.value.filter((i) => i.checked).length ===
    currentStudentList.value.length
);
const isGroupAllSelected = computed(() => {
  if (!groupListShowData.value.length) {
    return false;
  } else {
    return groupListShowData.value.filter((i) => !i.checked).length === 0;
  }
});

const handleClick = () => {
  allSelect.value = !allSelect.value;
  if (allSelect.value) {
    currentGroup.value.students.forEach((i) => {
      i.checked = false;
    });
  } else {
    currentGroup.value.students.forEach((i) => {
      i.checked = true;
    });
  }
};
const handleSelectStudent = (id, info) => {
  currentStudentList.value.find((i) => i.id === id).checked = !info.checked;
};
const handleCancelModal = () => {
  modalVisible.value = false;
};

const updateCurrentData = () => {
  currentGroup.value = groupListShowData.value.find(
    (i) => i.id === currentGroup.value?.id
  );
  currentStudentList.value = currentGroup.value?.students?.map((i) => {
    i.checked = currentStudentList.value.find((j) => j.id === i.id).checked;
    return i;
  });
};

// 多选学生发送评价
const addStudentEvaluation = async (val) => {
  const { norm_code, addPoint, single_opr_score } = val;
  const params: any = {};
  params.lesson_id = lessonId.value;
  params.norm_code = norm_code;
  params.students = currentStudentList.value
    .filter((i) => i.checked)
    .map((i) => ({
      student_id: i.id,
      score: parseInt(single_opr_score),
    }));
  let clearFunc = undefined;
  try {
    clearFunc = delayLoading(1000, "设置评分中，请稍后");
    await addStudentEvaluateRecord(params);
    clearFunc();
    handleAppraiseModalClose();
    if (currentGroupInfo.value.score_type === 2) {
      await setGroupEvaluateNormScoreByStudentSum({
        lesson_id: lessonId.value,
        group_plan_id: groupPlanId.value,
      });
    }
    animationtionInfo.value.score = parseInt(single_opr_score);
    animationtionInfo.value.visible = true;
    let key = setTimeout(() => {
      animationtionInfo.value.visible = false;
      clearTimeout(key);
    }, 1000);
    await handleUpdateStudentAndGroupData?.();
    updateCurrentData();
  } catch (e) {
    if (clearFunc) {
      clearFunc();
    }
    ElMessage.error({ message: "请求错误" });
    console.error(e);
  }
};

const isSendCurrentGroup = ref(false);

const addGroupEvaluation = async (val: any) => {
  const { norm_code, addPoint, single_opr_score, title } = val;
  console.log(norm_code, addPoint, single_opr_score);
  const params: any = {
    lesson_id: lessonId.value,
    norm_code,
    group_plan_id: groupPlanId.value,
  };

  let showMaskName = "";
  let showMaskAvatarId = "";

  if (isSendCurrentGroup.value) {
    params.groups = [
      {
        group_id: currentGroup.value.id,
        score: parseInt(single_opr_score),
      },
    ];
    showMaskName = currentGroup.value.name;
    showMaskAvatarId = currentGroup.value.avatarId;
  } else {
    const paramsGroups = groupListShowData.value.filter((i: any) => i.checked);
    showMaskName = paramsGroups[0].name;
    if (paramsGroups.length > 1) {
      showMaskName += ` 等${paramsGroups.length}组`;
    }
    showMaskAvatarId = paramsGroups[0].avatarId;
    params.groups = paramsGroups.map((i: any) => ({
      group_id: i.id,
      score: parseInt(single_opr_score),
    }));
  }

  let clearFunc = undefined;
  try {
    clearFunc = delayLoading(1000, "设置评分中，请稍后");
    await addGroupEvaluateRecord(params);
    // 数据埋点
    reportStat({
      moduleid: "tools",
      pageid: "classCommunication",
      eventid: "classCommunication_studentEvaluation",
      eventattr: {
        teacher_id: store.state.teacherId,
        result: params.groups,
      },
    });
    clearFunc();
    handleAppraiseModalClose();
    modalVisible.value = false;
    if (handleShowMask) {
      const img = require("@/assets/img/classroomInteraction/groupAvatar/" +
        showMaskAvatarId +
        ".png");
      const config = {
        isPraise: parseInt(single_opr_score) > 0,
        msg: title,
        point: Math.abs(parseInt(single_opr_score)),
        avatar: img,
        name: showMaskName,
      };
      handleShowMask(config);
    }
    await handleUpdateStudentAndGroupData?.();
    updateCurrentData();
  } catch (e) {
    if (clearFunc) {
      clearFunc();
    }
    ElMessage.error({ message: "请求错误" });
    console.error(e);
  }
};
// 给组内学生发送点评
const handleSelectSubmit = () => {
  if (!currentStudentList.value.filter((i) => i.checked).length) {
    ElMessage.info({
      message: "请选择学生",
    });
    return;
  }
  const info = {
    msg: "小组学生评价",
    autoClose: false,
  };
  if (handleShowAppraiseModal) {
    handleShowAppraiseModal(info, addStudentEvaluation);
  }
};

// 发送小组评价
const handleSelectGroupSubmit = (isCurrentSingle = false) => {
  isSendCurrentGroup.value = isCurrentSingle;
  if (
    !groupListShowData.value.filter((i) => i.checked).length &&
    !isSendCurrentGroup.value
  ) {
    ElMessage.info({
      message: "请选择小组",
    });
    return;
  }
  const info = {
    msg: "小组评价",
    autoClose: false,
  };
  if (handleShowAppraiseModal) {
    handleShowAppraiseModal(info, addGroupEvaluation);
  }
};
const handleCancelMultiSelect = () => {
  multiSelectAction.value = false;
  groupListShowData.value.forEach((i) => {
    i.checked = false;
  });
};

const randomModalVisible = ref(false);

const handleStartCreateGroup = () => {
  handleCreateGroup?.();
};


const sortType = inject<any>("orderGroup");
const orderFunc = inject<ClassroomInterationNS.SortListByOrderTypeFunc>(
  "sortListByOrderType"
);
// 传递小组数量
const giveGroupLenth: any = inject("groupLenth");
watch(
  () => [sortType.value, groupList.value],
  (val) => {
    if (val[0] !== undefined && orderFunc) {
      const res = orderFunc(groupList.value, val[0], true);
      groupListShowData.value = [];
      groupListShowData.value = res;
      giveGroupLenth?.(groupListShowData.value.length);
    }
  },
  { immediate: true }
);

watch(
  () => currentStudentList.value,
  (val) => {
    if (val?.length && val.filter((i) => !i.checked).length === 0) {
      allSelect.value = false;
    } else {
      allSelect.value = true;
    }
  },
  { immediate: true, deep: true }
);
watch(
  () => [isGroupAllSelected.value, multiSelectAction.value],
  (val) => {
    if (val[1]) {
      changeIsAllSelected?.(isGroupAllSelected.value);
    }
  },
  { immediate: true }
);

const onRandom = () => {
  randomModalVisible.value = true;
};

// 将节点挂载到body
const CIBodyRef: any = inject("CIBodyRef");
const setBodyRef = () => CIBodyRef.value;

const handleSubmitMultiSelect = () => {
  handleSelectGroupSubmit(false);
};

const handleSelectAllGroupBtn = () => {
  if (isGroupAllSelected.value) {
    groupListShowData.value.forEach((i) => {
      i.checked = false;
    });
  } else {
    groupListShowData.value.forEach((i) => {
      i.checked = true;
    });
  }
  // groupListShowData.value.forEach((i) => {
  //   i.checked = !isGroupAllSelected.value;
  // });
};

expose({
  onRandom,
  handleCancelMultiSelect,
  handleSubmitMultiSelect,
  handleSelectAllGroupBtn,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(groupList).length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", { class: "no-data-container" }, [
              _hoisted_3,
              _createElementVNode("div", { class: "no-data-text" }, [
                _createElementVNode("div", {
                  class: "no-data-btn",
                  onClick: handleStartCreateGroup
                }, " 快速分组 ")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupListShowData.value, (group) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "group-item",
            key: group.id
          }, [
            _createVNode(GroupCard, {
              onClick: ($event: any) => (handleOpenModal(group)),
              cardInfo: {
              groupName: group.name,
              avatar: group.avatarId + '.png',
              groupNumber: group.students.length,
            },
              "is-selected": _unref(multiSelectAction) && group.checked
            }, {
              point: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, "+" + _toDisplayString(group.addScore || 0), 1),
                  _createElementVNode("div", _hoisted_7, " -" + _toDisplayString(Math.abs(group.subtractScore) || 0), 1)
                ])
              ]),
              _: 2
            }, 1032, ["onClick", "cardInfo", "is-selected"])
          ]))
        }), 128))
      ]),
      _createVNode(BaseModal, {
        visible: modalVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (modalVisible.value = $event)),
        title: title.value,
        getContainer: setBodyRef
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentStudentList.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "student-item",
                key: item.id
              }, [
                _createVNode(StudentCard, {
                  key: item.id,
                  isSelect: item.checked,
                  "score-animation": {
                ...animationtionInfo.value,
                visible: item.checked && animationtionInfo.value.visible,
              },
                  info: {
                ...item,
                score: {
                  add: {
                    value: item.lesson_evaluate_total_score.find(
                      (i) => i.norm_type === 1
                    ).total_score,
                  },
                  reduce: {
                    value: Math.abs(
                      item.lesson_evaluate_total_score.find(
                        (i) => i.norm_type === 0
                      ).total_score
                    ),
                  },
                },
              },
                  showScore: true,
                  onOnClick: handleSelectStudent
                }, null, 8, ["isSelect", "score-animation", "info"])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: "all-select",
                onClick: handleClick
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["check-box", allSelect.value ? 'check-box-no-select' : 'check-box-select'])
                }, null, 2),
                _hoisted_11
              ]),
              _createElementVNode("div", {
                onClick: handleClick,
                class: "checkbox-mask"
              })
            ]),
            _createElementVNode("div", {
              class: "base-btn cancel",
              onClick: handleCancelModal
            }, "取消"),
            _createElementVNode("div", _hoisted_12, [
              (_unref(checkBoxChecked))
                ? (_openBlock(), _createElementBlock("text", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSelectGroupSubmit(true)))
                  }, "发送小组点评"))
                : (_openBlock(), _createElementBlock("text", {
                    key: 1,
                    onClick: handleSelectSubmit
                  }, "发送多人点评"))
            ]),
            _hoisted_13
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"]),
      _createVNode(RandomModal, {
        visible: randomModalVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (randomModalVisible.value = $event)),
        groupList: _unref(groupList),
        onOpenModal: handleOpenModal
      }, null, 8, ["visible", "groupList"]),
      (_unref(multiSelectAction))
        ? (_openBlock(), _createElementBlock("div", _hoisted_14))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})